import { render, staticRenderFns } from "./IconZonneEnergie.vue?vue&type=template&id=9bf004f4"
import script from "./IconZonneEnergie.vue?vue&type=script&lang=ts"
export * from "./IconZonneEnergie.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports